import { _t } from "core/language";
import VideoListItem from "core/components/VideoListItem";
import VideoListLoading from "./Loading";

const VideoList = ({ videos, loading }: { videos: any[], loading: boolean }) => {
  return (
    <div>
      <div className="mb-3.5 px-4">
        <label className="text-dark font-medium text-base">
          {_t('recipe.video.title')}
        </label>
      </div>
      <div className="flex overflow-x-auto no-scrollbar px-4">
        <div className="flex gap-2.5">
          {loading ? (
            Array.from(Array(5).keys()).map((e: number) =>
              <VideoListLoading key={e} />
            )
          ) : (
            videos?.map((item, key) => (<VideoListItem
              showIcon
              dataItem={item}
              name={item.title}
              image={item.thumbnail}
              type={2}
              key={key}
              className={`w-[140px]`}
              videoId={item.videoId}
            />))
          )}
        </div>
      </div>
    </div>
  )
}

export default VideoList
